import styled from '@emotion/styled'
import { ToggleButtonGroup as MuiToggleButtonGroup } from '@mui/material'
import { theme } from '../../themes/theme'

const { primaryButton, secondaryButton } = theme.colors

const ToggleButtonGroup = styled(MuiToggleButtonGroup)`
  .MuiToggleButton-root {
    text-transform: none;
    font-size: 14px;
    font-weight: 500;
    font-family: inherit;
    line-height: 15px;
    padding: 10px;

    border: 0.775px solid ${secondaryButton.border};
    color: ${secondaryButton.text};
    background: ${secondaryButton.background};

    :hover {
      border: 0.775px solid ${secondaryButton.hoverBorder};
      background: ${secondaryButton.hover};
      color: ${secondaryButton.text};
    }

    :disabled {
      background: ${secondaryButton.disabled};
      color: ${secondaryButton.disabledText};
      opacity: 0.65;
    }
  }

  .MuiToggleButton-root.Mui-selected {
    color: ${primaryButton.text};
    background: ${primaryButton.background};
    border: 0.775px solid ${primaryButton.border};

    :hover {
      background: ${primaryButton.hover};
      color: ${primaryButton.hoverText};
    }
  }

  .MuiToggleButtonGroup-firstButton {
    border-radius: ${theme.borderRadius.button} 0 0 ${theme.borderRadius.button};
    padding-left: 20px;
  }

  .MuiToggleButtonGroup-lastButton {
    border-radius: 0 ${theme.borderRadius.button} ${theme.borderRadius.button} 0;
    padding-right: 20px;
  }
`

export { ToggleButtonGroup }
